<div class="card-cell-header">
	@if (data.is_onvoldoende) {
		<div class="indicator-1jaar"></div>
	}
	<span class="card-cell-title">{{ data.pv_nm_indicator }}</span>
</div>
<app-linechart
	[props]="data.linechartProps"
	[class.invert-colors]="data.pv_nm_indicator === IndicatorNaamPrestatieanalyse.BEOOGD_I_R_T_BEHAALD_EINDUITSTROOMNIVEAU"
></app-linechart>
